import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import googleAnalytics from "@/store/statistics/google-analytics"

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
    modules: {
        googleAnalytics
    }
}
